'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = RouteConfig;

function RouteConfig($routeProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $routeProvider.when('/', {
        templateUrl: 'assets/html/ui/top_chart.html'
    }).when('/bp/:category', {
        templateUrl: 'assets/html/ui/top_chart.html'
    }).when('/:folder/:tpl', {
        templateUrl: function templateUrl(attr) {
            return 'assets/html/ui/' + attr.folder + '/' + attr.tpl + '.html';
        }
    }).when('/:tpl', {
        templateUrl: function templateUrl(attr) {
            return 'assets/html/ui/' + attr.tpl + '.html';
        }
    }).otherwise({
        redirectTo: '/'
    });
}

RouteConfig.$inject = ['$routeProvider', '$locationProvider'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/config/route.js
 ** module id = 9
 ** module chunks = 0
 **/